<template>
  <transition name="fade">
    <div class="userModal" v-if="show" v-on:click="modalClicked">
      <div class="overlay"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="title" v-if="detail">Edit Event</h4>
        <h4 class="title" v-else>Add Event</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="formCnt">
            <div class="fieldGroup">
              <div class="fieldCnt" :class="{hasError: form.title.error}">
                <label>Name</label>
                <input type="text" class="field" placeholder="Event name..."
                  v-model="form.title[lang]">
                <div class="fieldError" v-if="form.title.error">{{form.title.error}}</div>
              </div>
            </div>
            <div class="fieldGroup" v-if="1>2">
              <div class="fieldCnt" :class="{hasError: form.code.error}">
                <label>Code</label>
                <input type="text" class="field" placeholder="Event code..."
                  v-model="form.code.model">
                <div class="fieldError" v-if="form.code.error">{{form.code.error}}</div>
                <div class="fieldHint">This code will be used in link url to this event's invitation landing page.</div>
              </div>
            </div>
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Descriptions</label>
                <textarea rows="5" class="field" placeholder="Descriptions..."
                  v-model="form.descriptions[lang]"></textarea>
              </div>
            </div>
          </div>
          <div class="btnCnt">
            <div class="langSelectorBtn"
              v-on:click.stop="langSelectorOpen = !langSelectorOpen"
              v-if="1>2">
              <b>{{lang}}</b>
              <div class="langSelector" v-if="langSelectorOpen"
                v-on:click.stop="doNothing">
                <li v-on:click.stop="selectLang('en')">EN - English</li>
                <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
              </div>
            </div>

            <button class="btn btnSecondary" type="button" v-if="!loading"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit"
              :class="{btnLoading: loading}">
              <span>Save Changes</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      detail: null,
      loading: false,
      form: {
        title: { id: '', en: '', error: null },
        descriptions: { id: '', en: '' },
        code: { model: '', error: null },
      },
      lang: 'id',
      langSelectorOpen: false,
    };
  },
  methods: {
    modalClicked() {
      this.langSelectorOpen = false;
    },
    selectLang(lang) {
      this.langSelectorOpen = false;
      this.lang = lang;
    },
    open(d, n) {
      this.detail = d;
      this.form.title.id = (d && d.name) ? d.name : '';
      // this.form.title.en = (d && d.name) ? d.name.en : '';
      this.form.descriptions.id = (d && d.descriptions) ? d.descriptions : '';
      // this.form.descriptions.en = (d && d.descriptions) ? d.descriptions.en : '';
      this.lang = 'id';
      this.next = n;
      this.show = true;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    handleSubmit() {
      const formData = {
        // name: { id: this.form.title.id, en: this.form.title.en },
        // descriptions: { id: this.form.descriptions.id, en: this.form.descriptions.en },
        name: this.form.title.id,
        descriptions: this.form.descriptions.id,
      };
      if (!formData.name || formData.name.trim() === '') {
        this.form.title.error = 'Please input event name';
        return;
      }
      this.loading = true;
      this.$http.post(this.$config.uri('invitation/save'), formData).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) {
          this.form.title.error = r.data.status || 'Internal server error, please try again later';
          return;
        }
        this.close(true);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldError{
      display: block;
    }
  }
  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    transition: all .3s ease;
    width: 480px;
    padding: 40px 80px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4.title{
      font-size: 24px;
      margin: -20px -80px 0;
      padding: 0 80px 10px;
      border-bottom: #eee 1px solid;
    }
    .formCnt{
      overflow: auto;
      max-height: 60vh;
      margin: 0 -80px;
      padding: 20px 80px 10px;
      box-sizing: border-box;
    }
    .fieldGroup{
      .toggle{
        margin-top: 30px;
      }
      &.fg2b{
        .fieldCnt:first-child{
          width: calc(60% - 12px);
        }
        .fieldCnt:last-child{
          width: calc(40% - 12px);
        }
      }
    }
    .btnCnt{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -80px -40px;
      padding: 12px 30px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .langSelectorBtn{
        margin-right: auto;
        position: relative;
        border-radius: 50px;
        padding: 6px 16px;
        padding-left: 36px;
        transition: all .3s ease;
        cursor: pointer;
        margin-right: auto;
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          content: "";
          position: absolute;
          left: 12px; top: 0; bottom: 3px;
          width: 18px;
          background-image: url(../assets/language.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        b{
          font-weight: 600;
          text-transform: uppercase;
        }
        .langSelector{
          position: absolute;
          background-color: #fff;
          z-index: 7;
          bottom: 100%; left: 0;
          box-shadow: 0 0 6px rgba(0, 0, 0, .2);
          border-radius: 5px;
          padding: 8px 0;
          text-align: left;
          li{
            white-space: nowrap;
            list-style: none;
            padding: 8px 24px;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
      .btn{
        margin-left: 5px;
        &.saving{
          background-color: #ccc;
          color: #999;
          cursor: default;
          box-shadow: none;
        }
      }
    }
  }
}

.addMoreAnswer{
  margin-bottom: 24px;
  padding: 4px 14px 5px;
  border-radius: 50px;
  display: inline-block;
  font-size: 15px;
  color: #767676;
  transition: all .3s ease;
  cursor: pointer;
  &:hover{
    background-color: #eee;
    color: #0747a6;
  }
}

.mediaCnt{
  .field{
    cursor: pointer;
    padding: 18px 40px 19px;
    padding-left: 64px;
    position: relative;
    .mediaLabel{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      font-size: 17px;
    }
    .fieldImg{
      content: "";
      position: absolute;
      width: 46px; height: 46px;
      background-color: #ccc;
      border-radius: 5px;
      left: 6px; top: 6px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      &.noImg{
        background-image: url(../assets/image-black.png);
        background-size: 22px auto;
        opacity: .36;
        &.video{
          background-image: url(../assets/video-black.png);
        }
      }
    }
    .fieldMore{
      position: absolute;
      right: 8px; top: 11px;
      width: 34px; height: 34px;
      border-radius: 50%;
      background-size: 12px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/close.png);
      opacity: .36;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #ccc;
        opacity: .64;
      }
    }
  }
}
</style>
